import { Fragment } from 'react';
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider';
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types';
import QuoteOrderStatusBar, { QuoteOrderStatusBarNew, QuoteOrderStatusBarProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/QuoteOrderStatusBar';
import QuoteOrderWaitingResponseStepButtons, { QuoteOrderWaitingResponseStepButtonsNew } from '../QuoteOrderWaitingResponseStepButtons';

type QuoteOrderWaitingResponseStepHeaderProps = & QuoteOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const QuoteOrderWaitingResponseStepHeaderDecider: React.FC<QuoteOrderWaitingResponseStepHeaderProps> = ({...rest}) => {
    return (
        <AppStyleDecider DefaultComponent={QuoteOrderWaitingResponseStepHeaderDefault} NewComponent={QuoteOrderWaitingResponseStepHeaderNew} {...rest} />
    )
}

const QuoteOrderWaitingResponseStepHeaderDefault: React.FC<QuoteOrderWaitingResponseStepHeaderProps> = ({...rest}) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <QuoteOrderStatusBar {...rest} />
            <QuoteOrderWaitingResponseStepButtons {...rest} />
        </div>
    )
}

const QuoteOrderWaitingResponseStepHeaderNew: React.FC<QuoteOrderWaitingResponseStepHeaderProps> = ({...rest}) => {
    return (
        <Fragment>
            <QuoteOrderStatusBarNew {...rest} />
            <QuoteOrderWaitingResponseStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default QuoteOrderWaitingResponseStepHeaderDecider